// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { newSdSupportSearchBaseURL } from '../../constants/index';
import axios from 'axios';


const initialState = {
	loading: false,
	error: '',
	resource: [],
	filters: [],
	total: 0
};

export const getResourceLibraryFilters = createAsyncThunk('resourceLibrarySlice/getResourceLibraryFilters', async (query) => {
    try {

        return await axios.get(newSdSupportSearchBaseURL + "?q=*&locale=en-us&fl=sourceType,primaryImage,documentType,id,title,content,documentTypeDate&rows=9&fq=documentType:Press%20Release&groupBy=documentType,yearMonth,cqTagsName_s&sort=docModifiedDate", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});
export const getResourceLibrary = createAsyncThunk('resourceLibrarySlice/getResourceLibrary', async (query) => {
    try {
        return await axios.get(newSdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const resourceLibrarySlice = createSlice({
    name: 'resourceLibrary',
    initialState,
    reducers: {
        resetPage : (state) =>{
            state.total=0
            state.resource=[]
            state.filters=[]
        }
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(getResourceLibraryFilters.pending, (state) => {
                state.loading = true;
            })
            .addCase(getResourceLibraryFilters.fulfilled, (state, action) => {
				state.resource=action.payload.docs
				state.total=action.payload.total
                state.filters = action.payload.facet_fields;
                state.loading = false;

            })
            .addCase(getResourceLibraryFilters.rejected, (state, action) => {
                state.search.error = action.error.message;
                state.loading = false;
            })
            .addCase(getResourceLibrary.pending, (state) => {
                state.loading = true;
            })
            .addCase(getResourceLibrary.fulfilled, (state, action) => {
                state.resource=action.payload.docs
				state.total=action.payload.total
                state.filters = action.payload.facet_fields;
                state.loading = false;

            })
            .addCase(getResourceLibrary.rejected, (state, action) => {
                state.loading = false;
                // state.productCarousel.error = action.error.message;
            });
    },
});

export const { resetPage,resetSearchPage } = resourceLibrarySlice.actions;

export default resourceLibrarySlice.reducer;
